import { z } from 'zod';

export const CompleteOrganizationAsCompanyBodySchema = z.object({
  name: z.string().min(1),
  documentNumber: z.string().min(14),
  taxRegime: z.enum(['SIMPLES_NACIONAL', 'LUCRO_PRESUMIDO', 'LUCRO_REAL']),
  confirmed: z.literal(true),
  tradeName: z.string().nullable().optional(),
  stateRegistration: z.string().nullable().optional(),
  municipalRegistration: z.string().nullable().optional(),
  legalRepresentativeName: z.string().nullable().optional(),
  legalRepresentativeCpf: z.string().nullable().optional(),
  legalRepresentativeRole: z
    .enum(['PARTNER_ADMIN', 'DIRECTOR', 'ATTORNEY', 'ACCOUNTANT'])
    .nullable()
    .optional(),
});

export type CompleteOrganizationAsCompanyBody = z.infer<
  typeof CompleteOrganizationAsCompanyBodySchema
>;

export const CompleteOrganizationAsCompanyResponseSchema = z.object({
  organizationId: z.uuid(),
  placeId: z.uuid(),
  documentNumber: z.string(),
  personKind: z.literal('COMPANY'),
});

export type CompleteOrganizationAsCompanyResponse = z.infer<
  typeof CompleteOrganizationAsCompanyResponseSchema
>;
